import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../baseClasses/BaseComponent';
import ComboBox from '../ComboBox';

// Change DialogButton to the appropriate name
export class UserRolesComboBox extends BaseComponent {
  constructor(props) {
    super(props);
    let currentOption = props.currentOption ? props.currentOption : null;
    this.state = {
      roleList: [],
      selected: currentOption,
    };

    this.createRoleOptions = this.createRoleOptions.bind(this);
  }
  
  componentDidUpdate(prevProps){
    if (prevProps.currentOption != this.props.currentOption) {
      this.setState({ selected: this.props.currentOption });
    }
  }
  checkIfAdminCompanyIsTrue(user) {
    const userCompanies = user.companies;
    if(userCompanies){
      if (userCompanies.length === 0) {
        return false;
      }
      return userCompanies.some(company => company.admin_company === true);
    }
    else{
      return false;
    }
  }

  createRoleOptions() {
    const currentUser = this.props.currentUser;
    const myRole = currentUser && currentUser.role;
    if (myRole && currentUser) {
      const currentUserAdminCompany = this.checkIfAdminCompanyIsTrue(currentUser);
      const targetUserAdminCompany = this.checkIfAdminCompanyIsTrue(this.props.targetUser);
      const userRoles = this.props.userRoles ? this.props.userRoles : [];
      let filteredRoleList = userRoles.filter(role => {
        // `admin` is permissions.isSuperUser (super_admin), NOT "user's role name is admin".
        // When true, nearly all API roles are shown; the switch below only runs for company users without super_admin.
        if (this.props.admin) {
          if(role.name === 'super_user' && this.props.targetUser && this.props.targetUser.id){
            if(myRole.name === 'super_user' && currentUser.super_admin === true 
            && currentUserAdminCompany && targetUserAdminCompany){
              return true;
            }
            else{
              return false;
            }
          }
          else{
            return true;
          }     
        }
        else {
          if (role.name == 'super_user' || role.name == 'api_user' || role.name == 'file_integration') {
            return false;
          }
          else {
            switch (role.name) {
            case 'primary_contact':
              return myRole.name == 'primary_contact' || myRole.name == 'admin';
            case 'editor':
              return myRole.name == 'primary_contact' || myRole.name == 'admin' || myRole.name == 'editor';
            case 'standard_user':
              return true;
            case 'view_only':
              return true;
            case 'admin':
              return myRole.name == 'primary_contact' || myRole.name == 'admin';
            case 'insights':
              return myRole.name == 'primary_contact' || myRole.name == 'admin';
            default:
              return false;
            }
          }
        }
      });
      let roleList = filteredRoleList.map((role) => {
        return { type: role.id, name: role.description, role: role };
      });
      return roleList;
    }
    else {
      return null;
    }
  }

  handleRoleChange(type, option) {
    let role = this.props.userRoles.filter(role => {
      return role.id == parseInt(type, 10);
    });
    role = role[0];
    this.setState({
      selected: { type: type, name: role.description, role: role },
    });
    this.props.handleRoleChange(role);
  }

  render() {
    let { height, width, hasBorder, defaultText, displayFontStyle, currentOption, maxHeight, top, left, label, tabIndex,
      makeAbsolute, underlined, menuHeight } = this.props;

    height = this.props.height ? this.props.height : null;
    width = this.props.width ? this.props.width : null;
    hasBorder = this.props.hasBorder ? this.props.hasBorder : null;
    defaultText = this.props.defaultText ? this.props.defaultText : null;
    displayFontStyle = this.props.displayFontStyle ? this.props.displayFontStyle : null;
    currentOption = this.props.currentOption;
    maxHeight = this.props.maxHeight ? this.props.maxHeight : null;
    top = this.props.top ? this.props.top : null;
    left = this.props.left ? this.props.left : null;
    makeAbsolute = this.props.makeAbsolute ? this.props.makeAbsolute : null;
    label = this.props.label ? this.props.label : null;
    tabIndex = this.props.tabIndex ? this.props.tabIndex : null;
    underlined = this.props.underlined ? this.props.underlined : null;
    menuHeight = this.props.menuHeight ? this.props.menuHeight : null;

    let options = this.createRoleOptions();

    return (
      // Replace with the appropriate HTML
    <ComboBox id={'userRolesPicker'} options={options} height={height} width={width} hasBorder={hasBorder} defaultText={defaultText} 
      currentOption={currentOption} displayFontStyle={displayFontStyle } handleSelection={this.handleRoleChange}
      maxHeight={maxHeight} top={top} left={left} makeAbsolute={makeAbsolute} label={label} underlined={underlined}
      tabIndex={tabIndex} menuHeight={menuHeight}
    />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
    permissions: state.new_users.permissions,
    userRoles: state.new_users.userRoles,
  };
};

export default connect(mapStateToProps)(UserRolesComboBox);



// WEBPACK FOOTER //
// ./src/components/UserRolesComboBox/index.js